import React from "react";
import Com from "components/styledComp/CommStyledComp";

const SaaSCallout = () => {
  return (
    <Com.DivDetailSection border="false">
      <Com.DivCloudCallout>
        <Com.H3CalloutTitle>클라우드 역량을 실제 서비스에서 확인하세요</Com.H3CalloutTitle>
        <Com.PCalloutDescription>
          HyGateOne의 출입·권한·관제 기능과 클라우드 적용 방식을 자세히 살펴보세요.
        </Com.PCalloutDescription>
        <Com.DivCalloutActions>
          <Com.LinkCalloutPrimary to="/product/hygateone">
            제품 자세히 보기
          </Com.LinkCalloutPrimary>
          <Com.AnchorCalloutSecondary
            href="https://www.hygateone.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            HyGateOne 바로가기
          </Com.AnchorCalloutSecondary>
        </Com.DivCalloutActions>
      </Com.DivCloudCallout>
    </Com.DivDetailSection>
  );
};

export default SaaSCallout;
